import React from "react";
import { FiInbox } from "react-icons/fi";

/**
 * "The request succeeded and there is nothing here."
 *
 * ⚠️ Deliberately GREY, and deliberately never offers a Retry button. Retry is
 * the signal that something failed — see ErrorState. If an empty state could
 * also mean "the request blew up", an admin cannot tell whether a user really
 * has no schedules or whether the panel is broken. That ambiguity is the bug
 * this component pair exists to prevent.
 *
 * Pass `isFiltered` so the copy can distinguish "this user has none" from
 * "none match your filters", which are very different facts.
 */
export default function EmptyState({
  icon: Icon = FiInbox,
  title = "Nothing here",
  message,
  isFiltered = false,
  onClearFilters,
  actionLabel,
  onAction,
  compact = false,
}) {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center ${compact ? "py-8" : "py-14"}`}
    >
      <Icon className="text-slate-300" size={compact ? 32 : 44} />
      <h3 className="mt-4 text-base font-semibold text-slate-700">{title}</h3>
      {message && (
        <p className="mt-1 text-sm text-slate-500 max-w-sm">{message}</p>
      )}

      {isFiltered && onClearFilters && (
        <button
          type="button"
          onClick={onClearFilters}
          className="mt-4 rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors"
        >
          Clear filters
        </button>
      )}

      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-4 rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700 transition-colors"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
